import { formatDate } from "./dates";


// utils.js
export const cleanPayload = (obj) => {
    const cleaned = {};
    Object.keys(obj || {}).forEach((key) => {
        const value = obj[key];

        // ✅ skip null, undefined, empty string, and string with only spaces
        if (value !== null && value !== undefined && String(value).trim() !== "") {
            cleaned[key] = value;
        }
    });
    return cleaned;
};


// utils.js
export const capitalizeString = (str = "") => {
    if (typeof str !== "string") return str;

    const trimmed = str.trim().toLowerCase();
    if (!trimmed) return "";

    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};


export const toUpperCase = (str = "") => {
    if (typeof str !== "string") return str;
    return str.trim().toUpperCase();
};


export const formatLabel = (str = "") => {
    if (typeof str !== "string") return str;

    // Convert to normal string
    let cleaned = str.trim().replace(/_+/g, " ").toLowerCase();

    // Capitalize each word
    return cleaned
        .split(" ")
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};




export const formatValue = (value) => {
  if (value == null) return "";

  // Try date formatting first
  const dateFormatted = formatDate(value);
  if (dateFormatted !== value) return dateFormatted;

  // Then try label formatting
  const labelFormatted = formatLabel(value);
  if (labelFormatted !== value) return labelFormatted;

  return value;
};
